// extracted by mini-css-extract-plugin
export default {"normal":"Button_normal__BihPW","outlined":"Button_outlined__XMdxg"};